import { layoutOf } from "../../domain/layout";
import { dualAxle, singleAxle } from "../wheel-placements";
import { BUS } from "./dimensions";
const BUS_6_LAYOUT = layoutOf(["single", "dual"]);
const BUS_6_WHEELS = [
  ...singleAxle({
    axle: 1,
    x: BUS.steerAxleX,
    radius: BUS.wheelRadius,
    width: BUS.tyreWidth,
    halfTrack: BUS.steerHalfTrack
  }),
  ...dualAxle({
    axle: 2,
    x: BUS.driveAxleX,
    radius: BUS.wheelRadius,
    width: BUS.tyreWidth,
    halfTrack: BUS.dualHalfTrack,
    spacing: BUS.dualSpacing
  })
];
export {
  BUS_6_LAYOUT,
  BUS_6_WHEELS
};
